import React, { type FC, type ReactNode, useCallback } from 'react';
import { useErrorBoundary, usePanorama } from '@wix/yoshi-flow-editor';
import { UIErrorBoundary } from './UIErrorBoundary';
import { LoggerError } from '@constants';

type Props = {
  children: ReactNode;
  fallback: React.JSX.Element;
  forceRender?: boolean;
};

export const ErrorBoundary: FC<Props> = (props) => {
  const { children, fallback, forceRender } = props;
  // Catches errors from the controller
  const { error } = useErrorBoundary();
  // Catches errors from the components
  const panoramaClient = usePanorama();

  const handleUIError = useCallback(
    (componentError: unknown) => {
      if (componentError instanceof Error) {
        panoramaClient.logger().error(LoggerError.ComponentError, {
          error: componentError,
        });
        panoramaClient.errorMonitor().reportError(componentError);
      }
    },
    [panoramaClient],
  );

  if (forceRender || error) {
    return fallback;
  }

  return (
    <UIErrorBoundary fallback={fallback} onError={handleUIError}>
      {children}
    </UIErrorBoundary>
  );
};
